import React, { useEffect, useState } from 'react'
import Button from '../../../../atoms/Button/Button'
import FormTextarea, { ENTER } from '../../../../atoms/FormTextarea/FormTextarea'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import InfoLabel from '../../../../atoms/InfoLabel/InfoLabel'
import { api } from '../../../../../utils/index'
import {
  PORTI,
  VETTORI,
  INDIRIZZI,
} from '../../../../../utils/endpoint'
import { useSelector } from 'react-redux'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import useTrans from '../../../../../hooks/useTrans'
import { trackingCheckoutShipping } from '../../../../../utils/gtm'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import * as Sentry from '@sentry/browser'
import CheckoutOption from '../../../../molecules/CheckoutOption/CheckoutOption'
import IndirizzoCardCheckout from '../../../../molecules/IndirizzoCardCheckout/IndirizzoCardCheckout'
import SceltaIndirizzo from '../../../MyAccount/SceltaIndirizzo/SceltaIndirizzo'
import Alert from '../../../../atoms/Alert/Alert'

const FormIndirizzo = dynamic(() => import('../../../MyAccount/FormIndirizzo/FormIndirizzo'))

const IndirizzoSpedizione = ({
  setStep,
  step,
  props,
  carrello_main,
  handleScroll,
}) => {
  const { utente } = useSelector((state) => state.utente)
  const t = useTrans()
  const router = useRouter()

  const [selectedIndirizzo, setSelectedIndirizzo] = useState(
    props.values.indirizzo && props.values.indirizzo
  )
  const [loading, setLoading] = useState(false)
  const [porti, setPorti] = useState([])
  const [opzioniCorriere, setOpzioniCorriere] = useState([])
  const [loadingVettoriOrdine, setLoadingVettoriOrdine] = useState(false)
  const [indirizzo_sede, setIndirizzoSede] = useState()
  const [tipoSpedizione, setTipoSpedizione] = useState(props.values.tipo_spedizione)
  const [mioCorriere, setMioCorriere] = useState(false)
  const [indirizzi, setIndirizzi] = useState([])
  const [withMioCorriere, setWithMioCorriere] = useState(false)

  const [indirizzoScelto, setIndirizzoScelto] = useState()
  const [indirizzoEdit, setIndirizzoEdit] = useState()
  const [indirizzoTmp, setIndirizzoTmp] = useState()

  const [showSceltaIndirizzoModal, setShowSceltaIndirizzoModal] = useState(false)
  const [showFormIndirizzoModal, setShowFormIndirizzoModal] = useState(false)

  const fetchIndirizzi = async (id) => {
    await api.get(INDIRIZZI).then((res) => {
      const indirizziData = res.data ? [...res.data.filter((x) => !x.is_fatturazione)] : []

      const editedIndirizzo = indirizziData?.filter((item) => item?.id === id)?.[0]

      setIndirizzi(indirizziData)

      if (!selectedIndirizzo) {
        setSelectedIndirizzo(
          indirizziData.filter((item, i) => item.preferenziale === true)?.[0] ||
            indirizziData.filter((item, i) => item.is_sede === true)?.[0]
        )
      } else if (!id) {
        setSelectedIndirizzo(indirizziData.find((x) => x.id === selectedIndirizzo.id))
      }
      
      if (id) {
        if (editedIndirizzo?.email) {
          props?.setFieldValue('email_spedizione', editedIndirizzo?.email)
        }
      }

      if (id) {
        setSelectedIndirizzo(editedIndirizzo)
      }

      // se ho modificato l'indirizzoScelto allora lo riassegno perchè è stato modificato
      if (indirizzoScelto) {
        setIndirizzoScelto(indirizziData?.find((x) => x.id === indirizzoScelto.id))
      }

      setLoading(false)
    })
  }
  useEffect( () => {
    setLoading(true)
    !props.values?.email_spedizione && _preloadEmail()

    fetchIndirizzi()

    api
      .get(PORTI, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => setPorti(res.data.sort((a, b) => b?.id - a?.id)))
    api
      .get(VETTORI, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => setOpzioniCorriere(res.data))
    api
      .get('profilo-azienda/current-user/')
      .then((res) => setIndirizzoSede(res.data?.indirizzo_sede))
      .catch((err) => {
        console.log(err)
        Sentry.captureException(err)
      })
  }, [])

  useEffect(() => {
    props.setFieldValue('tipo_spedizione', tipoSpedizione)
  }, [tipoSpedizione])

  useEffect(() => {
    setTipoSpedizione()
    selectedIndirizzo && props.setFieldValue('indirizzo', selectedIndirizzo)
    selectedIndirizzo && selectedIndirizzo?.nazione?.codice !== 'IT' && setMioCorriere(null)
    props.setFieldValue('porto_id', undefined)
    props.setFieldValue('porto', undefined)
    props.setFieldValue('vettore_id', undefined)
    props.setFieldValue('vettore', undefined)
    props.setFieldValue('altro_vettore', undefined)
  }, [selectedIndirizzo])


  const _preloadEmail = () => {
    if (selectedIndirizzo?.email) {
      props.setFieldValue('email_spedizione', selectedIndirizzo?.email)

      return selectedIndirizzo?.email
    } else {
      props.setFieldValue('email_spedizione', indirizzo_sede ? indirizzo_sede : utente?.email)

      return indirizzo_sede?.email ? indirizzo_sede?.email : utente?.email
    }
  }

  const showModals = (showSceltaIndirizzo, showFormIndirizzo) => {
    setShowFormIndirizzoModal(showFormIndirizzo)
    setShowSceltaIndirizzoModal(showSceltaIndirizzo)
  }

  const onClose = async (id) => {
    await fetchIndirizzi(id)
  }

  const handleAddIndirizzoInModal = () => {
    setIndirizzoEdit(null)
    showModals(false, true)
  }

  const handleSetIndirizzoInModal = () => {
    onClose(indirizzoTmp)
    setIndirizzoTmp(null)
    showModals(false, false)
  }

  const handleEditIndirizzoInModal = (indirizzo) => {
    setIndirizzoEdit(indirizzo)
    showModals(false, true)
  }

  const handleDeleteIndirizzoInModal = (indirizzoId) => {
    api
      .delete(`${INDIRIZZI}${indirizzoId}/`, { params: { lang: router.locale } })
      .then((response) => {
        onClose()
      })
      .catch((error) => console.log(error))
  }

  const handleAnnullaIndirizzoInModal = () => {
    setIndirizzoEdit(null)
    showModals(true, false)
  }

  const handleSaveIndirizzoInModal = () => {
    onClose(indirizzoTmp)
    setIndirizzoTmp(null)
    showModals(true, false)
  }

  return loading ? (
    <LoadingSvg />
  ) : (
    <>
      <div className="checkout__spedizione">
        <div className="checkout__section">
          <IndirizzoCardCheckout
            variant="spedizione"
            indirizzo={selectedIndirizzo}
            onClick={() => {
              if (selectedIndirizzo) {
                setIndirizzoScelto(selectedIndirizzo)
                showModals(true, false)
              } else {
                setIndirizzoScelto()
                handleAddIndirizzoInModal()
              }
            }}
          />

          <FormField
            label={t('E-mail per avviso della spedizione')}
            status={
              props.touched.email_spedizione
                ? props.errors.email_spedizione
                  ? 'error'
                  : null
                : null
            }
            errorMessage={props.touched.email_spedizione && props.errors.email_spedizione}
            className="checkout__formfield"
          >
            <FormInput
              onBlur={props.handleBlur('email_spedizione')}
              placeholder={t('Email per avviso spedizione')}
              value={
                props.values.email_spedizione === null || undefined
                  ? _preloadEmail()
                  : props.values.email_spedizione
              }
              onChange={(e) => props.setFieldValue('email_spedizione', e.target.value)}
            />
          </FormField>
          <FormField label={t('Note Spedizione')} className="checkout__formfield">
            <FormTextarea
              placeholder={t("Inserisci informazioni relative all'ordine - Note Spedizione")}
              value={props.values.note_spedizione}
              onChange={(e) => props.setFieldValue('note_spedizione', e.target.value)}
              preventKeys={[ENTER]}
            />
          </FormField>
        </div>

        <div className="checkout__section">
          <p className="checkout__section-title">{t('Tipo di spedizione')}</p>
          {loadingVettoriOrdine ? (
            <LoadingSvg />
          ) : (
            <FormField className="checkout__formfield">
              {porti &&
                porti.map((porto) => (
                  <div
                    key={porto.id}
                    className={
                      'checkout__option' +
                      (tipoSpedizione === porto.modalita ? ' checkout__option--selected' : '')
                    }
                  >
                    <FormRadio
                      checked={
                        mioCorriere
                          ? selectedIndirizzo?.nazione?.codice === 'IT' &&
                            porto?.modalita !== 'porto_franco'
                            ? true
                            : false
                          : tipoSpedizione === porto?.modalita
                      }
                      label={
                        porto.modalita === 'porto_franco' ? (
                          <InfoLabel
                            label={t('Spedizione con corriere Sipec ed addebito in fattura')}
                            tooltipLabel={t(
                              'Il trasporto sarà effettuato dai corrieri di Sipec e ti verrà addebitato in fattura'
                            )}
                            tooltipPos="bottom"
                            className="info-label__icon-wrapper"
                          />
                        ) : (
                          t('Spedizione con mio corriere in porto assegnato')
                        )
                      }
                      onClick={() => {
                        const fromItaly = selectedIndirizzo?.nazione?.codice === 'IT'
                        setTipoSpedizione(porto.modalita)
                        props.setFieldValue('porto', porto)
                        props.setFieldValue('porto_id', porto.id)
                        props.setFieldValue('vettore_id', undefined)
                        props.setFieldValue('vettore', undefined)
                        props.setFieldValue('altro_vettore', undefined)
                        fromItaly
                          ? setMioCorriere(porto.modalita === 'porto_franco' ? false : true)
                          : setMioCorriere(false)
                        
                      }}
                    />
                  </div>
                ))}
            </FormField>
          )}
        </div>

        {mioCorriere && opzioniCorriere?.length > 0 && (
          <>
            <div className="checkout__section">
              <p className="checkout__section-title">
                {t('Scegli il servizio di spedizione più adatto alle tue esigenze')}
              </p>
              <div className="checkout__spedizione__section-alert">
                <Alert
                  hideDefaultPrefix
                  placeholder={
                    t("Scegliendo la spedizione con il vostro corriere in porto assegnato le spese di spedizione verranno <strong>addebitate dal corriere all'indirizzo di destinazione della merce</strong>")
                  }
                  variant="error"
                />
              </div>
              <FormField className="checkout__formfield">
                {opzioniCorriere && opzioniCorriere.map((vettore) => (
                  <CheckoutOption
                    title={vettore.descrizione}
                    // description={}
                    checked={vettore.id === props.values.vettore_id}
                    onClick={() => {
                      setWithMioCorriere(false)
                      setTipoSpedizione(vettore.descrizione)
                      props.setFieldValue('vettore_id', vettore.id)
                      props.setFieldValue('vettore', vettore)
                      props.setFieldValue('altro_vettore', undefined)
                    }}
                    fullClick
                    key={vettore.id}
                  />
                ))}
                <CheckoutOption
                  title={t('Mio corriere: mi occupo io di prenotare il ritiro')}
                  checked={tipoSpedizione === 'mio_corriere'}
                  onClick={() => {
                    setWithMioCorriere(true)
                    setTipoSpedizione('mio_corriere')
                    props.setFieldValue('vettore_id', undefined)
                    props.setFieldValue('vettore', undefined)
                  }}
                  fullClick
                />
              </FormField>
              {withMioCorriere && (
                <div className="checkout__spedizione__altrocorriere">
                  <FormField label={t('Note sul corriere (Facoltativo)')}>
                    <FormInput
                      placeholder={t('inserisci il nome del corriere che effettuerà il ritiro')}
                      onChange={(e) => {
                        props.setFieldValue('vettore_id', undefined)
                        props.setFieldValue('vettore', undefined)
                        props.setFieldValue('altro_vettore', e.target.value)
                      }}
                    />
                  </FormField>
                  <Button
                    label={t('Conferma')}
                    variant="secondary"
                    size="medium"
                    onClick={() => setWithMioCorriere(false)}
                  />
                </div>
              )}
            </div>
          </>
        )}

        {
          <Button
            disabled={
              tipoSpedizione &&
              props.values.tipo_spedizione !== 'Spedizione' &&
              (tipoSpedizione === 'porto_assegnato' ? (props.values.vettore_id || props.values.altro_vettore || selectedIndirizzo?.nazione?.codice !== 'IT') : true) && // se porto_franco il vettore non è obbligatorio, se porto_assegnato allora è obbligatorio un vettore o un altro_vettore ma solo se indirizzo non è estero
              selectedIndirizzo &&
              props.values.indirizzo &&
              !props.errors.email_spedizione
                ? false
                : true
            }
            label={t('Conferma indirizzo')}
            variant="primary"
            size="medium"
            onClick={() => {
              setStep(step + 1)
              handleScroll()
              trackingCheckoutShipping(
                carrello_main,
                mioCorriere ? 'shipping_my_courier' : 'shipping_with_sipec'
              )
            }}
          />
        }
      </div>

      {showSceltaIndirizzoModal && indirizzoScelto?.id && (
        <SceltaIndirizzo
          indirizzo={indirizzoScelto}
          indirizzi={indirizzi.filter((x) => x.id !== indirizzoScelto?.id)}
          setIndirizzo={setIndirizzoTmp}
          handleAddIndirizzo={handleAddIndirizzoInModal}
          handleSetIndirizzo={handleSetIndirizzoInModal}
          handleEditIndirizzo={handleEditIndirizzoInModal}
          handleDeleteIndirizzo={handleDeleteIndirizzoInModal}
          onClose={() => showModals(false, false)}
        />
      )}

      {showFormIndirizzoModal && (
        <FormIndirizzo
          variant="modal"
          onClose={() => {
            handleAnnullaIndirizzoInModal()
            onClose()
          }}
          isModal={true}
          editIndirizzo={indirizzoEdit}
          handleSaveIndirizzo={handleSaveIndirizzoInModal}
        />
      )}
    </>
  )
}

export default IndirizzoSpedizione
